<template lang="pug">
  modal(@closeModal='closeModal' :class='modalProps.scopeStyle' :closeButton='modalProps.showCloseButton')
    .column.middle.center.success-modal-container
      img.m4-top-2.m4-bottom-5(
        :src='modalProps.icon || iconCheck'
        :class='{ ".success-img" : modalProps.icon }'
        alt='success'
      )
      h1.success-title.title-medium.text-center {{ modalProps.title }}
      p.dark-gray.m4-bottom-13.success-subtitle(v-if='modalProps.subtitle') {{ modalProps.subtitle }}
      button.primary-button.m4-top-3(
        v-if='modalProps.buttonText'
        @click='hideElement({ element: "successModal" })'
        type='button'
      ) {{ modalProps.buttonText }}
</template>

<script>
import { mapState, mapActions } from 'vuex'

import iconCheck from '@/assets/ic_check.svg'

import Modal from '../Modal'

export default {
  components: { Modal },
  props: {
    onClose: { type: Function, required: false }
  },
  data() {
    return {
      iconCheck
    }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.successModal.props
    })
  },
  methods: {
    ...mapActions([
      'hideElement'
    ]),
    closeModal() {
      this.hideElement({ element: 'successModal' })
      if (this.modalProps.onClose) this.modalProps.onClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.success-img {
  height: 50px;
  width: 50px;
}

.success-title {
  margin-bottom: 13px;
}
</style>
